import { render, staticRenderFns } from "./InstagramLogo.vue?vue&type=template&id=358b5d67&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b5d67",
  null
  
)

export default component.exports